module.exports = __webpack_public_path__ + "329ad6261d533473bfee40d40605e10a.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsoft/assets/813.png
// module id = 1716
// module chunks = 2